interface Props {
  title?: string;
  description?: string;
}

export function ComingSoonNotice({
  title = 'Coming soon',
  description = 'We\'re putting the finishing touches on this — check back shortly.',
}: Props) {
  return (
    <div className="rounded-xl border border-gold/40 bg-gold/10 px-4 py-3 text-center">
      <div className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-gold-deep">{title}</div>
      <p className="mt-1 text-xs leading-relaxed text-ink-soft">{description}</p>
    </div>
  );
}
